import { CubeBuilder, NOOP_VOID, Place } from 'wdc-cube'

import { Places } from './Constants'
import { AnalisePresenter } from './modules/analise'
import { AnaliseFormPresenter } from './modules/analise/form'
import { RegraFormPresenter } from './modules/analise/regra'
import { CondicaoFormPresenter } from './modules/analise/regra/condicao'
import { AnaliseSelectPresenter } from './modules/analise/select'
import { BorderoPresenter } from './modules/bordero'
import BorderoFormPresenter from './modules/bordero/form/bordero_form.presenter'
import { ResultadoAnalisePresenter } from './modules/bordero/resultado'
import { DialogoResultadoPresenter } from './modules/bordero/resultado-detalhado/dialogo-resultado'
import ResultadoDetalhadoAnalisePresenter from './modules/bordero/resultado-detalhado/resultado_detalhado_analise.presenter'
import StatusProcessamentoPresenter from './modules/bordero/status-processamento/status_processamento.presenter'
import { GrupoPresenter } from './modules/grupo'
import { GrupoFormPresenter } from './modules/grupo/form'
import { IntegracaoMonitoramentoPresenter } from './modules/integracao'
import { IntegracaoMonitoramentoFormPresenter } from './modules/integracao/form'
import ResultadoAnaliseVisaoCedentePresenter from './modules/integracao/resultado/resultado_analise_visao_cedente.presenter'
import { PFPresenter } from './modules/pf'
import { PJPresenter } from './modules/pj'
import { RestrictedPresenter } from './modules/restricted/Restricted.presenter'
import { SerasaHistoryPresenter } from './modules/serasa-history'
import SerasaPresenter from './modules/serasa/serasa.presenter'
import { SerproPresenter } from './modules/serpro'

let buildOnce = () => {
    CubeBuilder.build({
        restricted: {
            presenter: Place.creator(RestrictedPresenter, Places, 'restricted')
        },
        pj: {
            presenter: Place.creator(PJPresenter, Places, 'pj')
        },
        pf: {
            presenter: Place.creator(PFPresenter, Places, 'pf')
        },
        serasa: {
            presenter: Place.creator(SerasaPresenter, Places, 'serasa')
        },
        serasaHistory: {
            presenter: Place.creator(SerasaHistoryPresenter, Places, 'serasaHistory')
        },
        serpro: {
            presenter: Place.creator(SerproPresenter, Places, 'serpro')
        },
        grupo: {
            presenter: Place.creator(GrupoPresenter, Places, 'grupo'),
            grupoForm: {
                presenter: Place.creator(GrupoFormPresenter, Places, 'grupoForm'),
                analiseSelect: {
                    presenter: Place.creator(AnaliseSelectPresenter, Places, 'analiseSelect')
                }
            }
        },
        analise: {
            presenter: Place.creator(AnalisePresenter, Places, 'analise'),
            analiseForm: {
                presenter: Place.creator(AnaliseFormPresenter, Places, 'analiseForm'),
                regraForm: {
                    presenter: Place.creator(RegraFormPresenter, Places, 'regraForm'),
                    condicaoForm: {
                        presenter: Place.creator(CondicaoFormPresenter, Places, 'condicaoForm')
                    }
                }
            }
        },
        monitorados: {
            presenter: Place.creator(IntegracaoMonitoramentoPresenter, Places, 'integracaoMonitoramento'),
            borderoForm: {
                presenter: Place.creator(IntegracaoMonitoramentoFormPresenter, Places, 'integracaoMonitoramentoForm')
            },
            resultadoAnalise: {
                presenter: Place.creator(ResultadoAnaliseVisaoCedentePresenter, Places, 'resultadoAnaliseVisaoCedente')
            }
        },
        bordero: {
            presenter: Place.creator(BorderoPresenter, Places, 'bordero'),
            borderoForm: {
                presenter: Place.creator(BorderoFormPresenter, Places, 'borderoForm')
            },
            resultadoAnalise: {
                presenter: Place.creator(ResultadoAnalisePresenter, Places, 'resultadoAnalise')
            },
            statusProcessamento: {
                presenter: Place.creator(StatusProcessamentoPresenter, Places, 'statusProcessamentoBordero')
            },
            resultadoDetalhadoAnalise: {
                presenter: Place.creator(ResultadoDetalhadoAnalisePresenter, Places, 'resultadoDetalhadoAnalise'),
                dialogResultadoDetalhadoAnalise: {
                    presenter: Place.creator(DialogoResultadoPresenter, Places, 'dialogoResultadoDetalhadoAnalise')
                }
            }
        }
    })

    buildOnce = NOOP_VOID
}

export function buildCube() {
    buildOnce()
    return Places
}
